'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withCarousel = exports.CarouselSubscriber = exports.CarouselBroadcast = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBroadcast = require('react-broadcast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CAROUSEL_CHANNEL = 'carouselChannel';

var CarouselBroadcast = function CarouselBroadcast(_ref) {
    var carousel = _ref.carousel,
        props = (0, _objectWithoutProperties3.default)(_ref, ['carousel']);
    return _react2.default.createElement(_reactBroadcast.Broadcast, (0, _extends3.default)({}, props, { compareValues: _isEqual3.default, channel: CAROUSEL_CHANNEL, value: carousel }));
};
CarouselBroadcast.propTypes = {
    children: _propTypes2.default.node.isRequired,
    carousel: _propTypes2.default.shape({
        theme: _propTypes2.default.object,
        currentSlide: _propTypes2.default.number.isRequired,
        infinite: _propTypes2.default.bool.isRequired,
        onSlideChange: _propTypes2.default.func.isRequired,
        totalSlides: _propTypes2.default.number.isRequired,
        setTotalSlides: _propTypes2.default.func.isRequired
    }).isRequired
};

var CarouselSubscriber = function CarouselSubscriber(props) {
    return _react2.default.createElement(_reactBroadcast.Subscriber, (0, _extends3.default)({}, props, { channel: CAROUSEL_CHANNEL }));
};
CarouselSubscriber.propTypes = {
    children: _propTypes2.default.func.isRequired
};

var withCarousel = function withCarousel(Component) {
    var DecoratedComponent = function DecoratedComponent(props) {
        return _react2.default.createElement(
            CarouselSubscriber,
            null,
            function (carousel) {
                return _react2.default.createElement(Component, (0, _extends3.default)({}, props, { carousel: carousel }));
            }
        );
    };

    DecoratedComponent.displayName = 'withCarousel(' + (Component.displayName || Component.name) + ')';
    return DecoratedComponent;
};

exports.CarouselBroadcast = CarouselBroadcast;
exports.CarouselSubscriber = CarouselSubscriber;
exports.withCarousel = withCarousel;
//# sourceMappingURL=with-carousel.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/with-carousel.js
 ** module id = 117
 ** module chunks = 1
 **/